/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDomainOffline = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m18.329 19.743 3.964 3.964 1.414-1.414-22-22L.293 1.707l3.964 3.964A9.959 9.959 0 0 0 2 12c0 5.523 4.477 10 10 10a9.959 9.959 0 0 0 6.329-2.257zm-1.423-1.423a8.034 8.034 0 0 1-.541.386c.112-.202.217-.406.317-.61zM14.586 16l.58.58A10.723 10.723 0 0 1 13 19.93V16zm-6-6L11 12.414V14H8.119a12.642 12.642 0 0 1 .09-4zm-2-2H5.07c.183-.316.387-.619.61-.906zM22 12a9.955 9.955 0 0 1-1.247 4.84L17.914 14h1.834a8.047 8.047 0 0 0 0-4h-1.955c.195 1.259.244 2.601.084 3.963l-1.906-1.906A13.231 13.231 0 0 0 15.766 10h-1.852L11 7.086V4.185c-.388.328-.84.865-1.283 1.618L7.161 3.247a9.932 9.932 0 0 1 3.362-1.139l.002-.001C11.006 2.036 11.5 2 12 2c5.523 0 10 4.477 10 10zM4.252 10h1.93a14.724 14.724 0 0 0-.08 4h-1.85a8.047 8.047 0 0 1 0-4zM11 16v3.938l-.02-.002A10.678 10.678 0 0 1 8.594 16zm-3.403 2.68A8.04 8.04 0 0 1 5.07 16H6.5c.254.905.613 1.805 1.097 2.68zM17.348 8h1.582a8.04 8.04 0 0 0-2.719-2.803c.444.825.836 1.773 1.137 2.803zM13 4.206V8h2.251a12.132 12.132 0 0 0-.88-2c-.47-.84-.956-1.435-1.371-1.794z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDomainOffline as DomainOffline };
